import React, { useState } from 'react'
import classnames from 'classnames'

import styles from './readMore.module.scss'

export interface ReadMoreProps {
  children: string
  className?: string
}
const ReadMore = ({ children, className }: ReadMoreProps) => {
  const text = children
  const size = text.length
  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(prevState => !prevState)
  }
  const classes = classnames(styles.container, className)
  return (
    <div className={classes}>
      {isReadMore && size > 146 ? text.slice(0, 146) : text}
      {size > 146 && (
        <span onClick={toggleReadMore} className={styles.container__readOrHide}>
          ... <u> {isReadMore ? 'Read more' : 'Show less'}</u>
        </span>
      )}
    </div>
  )
}
export default ReadMore
